import {
  FadvInput
} from "./chunk.H5PU4Z54.js";
import {
  FormControl
} from "./chunk.HH2JJZ37.js";
import {
  l as l2
} from "./chunk.SQVLNLTX.js";
import {
  createPopper
} from "./chunk.A364I6JA.js";
import {
  animateTo,
  stopAnimations
} from "./chunk.JEYCYKK2.js";
import {
  booleanAttributeConverter
} from "./chunk.MIOPVZYG.js";
import {
  autocomplete_styles_default
} from "./chunk.D4I4LINN.js";
import {
  watch
} from "./chunk.UW2NVD5N.js";
import {
  l
} from "./chunk.SUTDMD3F.js";
import {
  emit,
  waitForEvent
} from "./chunk.C4ZTYQN4.js";
import {
  getAnimation,
  setDefaultAnimation
} from "./chunk.456HIP2G.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  e,
  i,
  n,
  t
} from "./chunk.D5EJUUKV.js";
import {
  $,
  w
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/autocomplete/autocomplete.ts
import { t as t2 } from "i18next";
var FadvAutocomplete = class extends FormControl {
  constructor() {
    super(...arguments);
    this.open = false;
    this.hasSelectedMenuItem = false;
    this.suggestions = [];
    this.clearable = false;
    this.required = false;
    this.spellcheck = true;
    this.value = "";
  }
  connectedCallback() {
    super.connectedCallback();
    this.handleDocumentEventOutsideElement = this.handleDocumentEventOutsideElement.bind(this);
    this.handleDocumentKeyDown = this.handleDocumentKeyDown.bind(this);
    this.resizeObserver = new ResizeObserver(() => this.handleResize());
    this.resizeObserver.observe(this);
  }
  disconnectedCallback() {
    this.destroyPopover();
    this.resizeObserver.unobserve(this);
  }
  addOpenListeners() {
    document.addEventListener("focusin", this.handleDocumentEventOutsideElement);
    document.addEventListener("keydown", this.handleDocumentKeyDown);
    document.addEventListener("mousedown", this.handleDocumentEventOutsideElement);
  }
  removeOpenListeners() {
    document.removeEventListener("focusin", this.handleDocumentEventOutsideElement);
    document.removeEventListener("keydown", this.handleDocumentKeyDown);
    document.removeEventListener("mousedown", this.handleDocumentEventOutsideElement);
  }
  handleDocumentEventOutsideElement(event) {
    const path = event.composedPath();
    if (this && !path.includes(this)) {
      this.hide();
    }
  }
  handleDocumentKeyDown(event) {
    if (!this.open)
      return;
    if (!this.menu)
      return;
    const menuItems = this.menu.getAllItems();
    const firstMenuItem = menuItems[0];
    const lastMenuItem = menuItems[menuItems.length - 1];
    if (event.key === "Tab") {
      this.hide();
      return;
    }
    if (event.key === "Escape" || event.key === "Enter") {
      event.preventDefault();
      this.hide();
      this.input.focus({ preventScroll: true });
      return;
    }
    if (["ArrowDown", "ArrowUp"].includes(event.key)) {
      event.preventDefault();
      if (event.key === "ArrowDown" && firstMenuItem) {
        this.menu.setCurrentItem(firstMenuItem);
        firstMenuItem.focus();
        return;
      }
      if (event.key === "ArrowUp" && lastMenuItem) {
        this.menu.setCurrentItem(lastMenuItem);
        lastMenuItem.focus();
      }
    }
  }
  createPopover() {
    this.popoverInstance = createPopper(this.host, this.positioner, {
      placement: "bottom-start",
      strategy: "fixed",
      modifiers: [
        {
          name: "flip",
          options: {
            boundary: "viewport"
          }
        },
        {
          name: "offset",
          options: {
            offset: [0, 8]
          }
        }
      ]
    });
  }
  handleResize() {
    this.panel.style.width = `${this.input.clientWidth}px`;
  }
  async handleOpenChange() {
    var _a;
    if (this.open) {
      emit(this, "sl-show");
      await stopAnimations(this);
      this.addOpenListeners();
      this.createPopover();
      (_a = this.popoverInstance) == null ? void 0 : _a.update();
      this.panel.hidden = false;
      const { keyframes, options } = getAnimation(this, "autocomplete.show");
      await animateTo(this.panel, keyframes, options);
      emit(this, "sl-after-show");
    } else {
      emit(this, "sl-hide");
      await stopAnimations(this);
      this.removeOpenListeners();
      const { keyframes, options } = getAnimation(this, "autocomplete.hide");
      await animateTo(this.panel, keyframes, options);
      this.panel.hidden = true;
      this.destroyPopover();
      emit(this, "sl-after-hide");
    }
  }
  destroyPopover() {
    var _a;
    (_a = this.popoverInstance) == null ? void 0 : _a.destroy();
  }
  handleSuggestionsChange() {
    if (this.suggestions.length && this.hasFocus && !this.hasSelectedMenuItem) {
      this.show();
    } else {
      this.hide();
    }
  }
  renderMenu() {
    if (!this.suggestions.length || !this.open)
      return w;
    const suggestionMenuItems = this.suggestions.map(({ label, value }) => $`<fadv-menu-item value=${value}>${label}</fadv-menu-item>`);
    return $`<fadv-menu scrollable class="select__menu select__scroll-menu">${suggestionMenuItems}</fadv-menu>`;
  }
  focus(options) {
    this.input.focus(options);
  }
  blur() {
    this.input.blur();
  }
  select() {
    return this.input.select();
  }
  setSelectionRange(selectionStart, selectionEnd, selectionDirection = "none") {
    return this.input.setSelectionRange(selectionStart, selectionEnd, selectionDirection);
  }
  setRangeText(replacement, start, end, selectMode = "preserve") {
    this.input.setRangeText(replacement, start, end, selectMode);
    if (this.value !== this.input.value) {
      this.value = this.input.value;
      emit(this, "sl-input");
      emit(this, "sl-change");
      this.hasSelectedMenuItem = false;
    }
  }
  handleClearClick(event) {
    this.value = "";
    emit(this, "sl-clear");
    emit(this, "sl-input");
    emit(this, "sl-change");
    this.input.focus();
    this.hasSelectedMenuItem = false;
    event.stopPropagation();
  }
  handleDisabledChange() {
    if (this.input) {
      this.input.disabled = this.disabled;
      if (this.open)
        this.open = false;
    }
  }
  handleInput() {
    this.value = this.input.value;
    emit(this, "sl-input");
    this.hasSelectedMenuItem = false;
  }
  renderClearable() {
    var _a;
    if (!this.clearable)
      return w;
    if (((_a = this.value) == null ? void 0 : _a.length) <= 0)
      return w;
    return $`<button aria-label=${t2("components:common.clearEntry")} part="clear-button" class="input__clear" type="button" @click=${this.handleClearClick} tabindex="-1" ><slot name="clear-icon"><fadv-icon name="circle-xmark" library="solid"></fadv-icon></slot></button>`;
  }
  handleMenuItemSelection(event) {
    const { item } = event.detail;
    const menuItems = this.menu.getAllItems();
    const oldValue = this.value;
    menuItems.forEach((menuItem) => {
      menuItem.checked = menuItem === item;
    });
    this.value = item.value;
    event.stopPropagation();
    emit(this, "sl-select", { detail: { item } });
    if (this.value !== oldValue) {
      emit(this, "sl-input");
      emit(this, "sl-change");
    }
    this.hide().then(() => {
      const lengthOfInput = this.input.value.length;
      this.input.focus({ preventScroll: true });
      this.input.selectionStart = lengthOfInput;
      this.input.selectionEnd = lengthOfInput;
    });
    this.hasSelectedMenuItem = true;
  }
  async handleFocus() {
    if (this.disabled)
      return;
    super.handleFocus();
  }
  async show() {
    if (!this.suggestions.length)
      return void 0;
    if (this.disabled) {
      this.open = false;
      return void 0;
    }
    if (this.open)
      return void 0;
    this.open = true;
    return waitForEvent(this, "sl-after-show");
  }
  async hide() {
    if (!this.open)
      return void 0;
    this.open = false;
    return waitForEvent(this, "sl-after-hide");
  }
  handleBlur() {
    if (this.open)
      return;
    super.handleBlur();
  }
  handleChange() {
    this.hasSelectedMenuItem = false;
    this.value = this.input.value;
    emit(this, "sl-change");
  }
  handleClick() {
    this.hasSelectedMenuItem = false;
    if (!this.open && this.suggestions.length) {
      this.show();
      this.input.focus({ preventScroll: true });
    }
  }
  handleKeyup(event) {
    if (event.key === "Tab") {
      this.hasSelectedMenuItem = false;
    }
  }
  renderControl() {
    var _a;
    return $`<span part="prefix" class="form-control__control--prefix"><slot name="prefix"></slot></span><div class="form-control__control-host">${this.renderFloatingLabel()}<input size="1" part="input" id=${this.inputId} class="form-control__control" type="text" name=${l(this.name)} ?disabled=${this.disabled} ?readonly=${this.readonly} ?required="${this.required}" minlength=${l(this.minlength)} maxlength=${l(this.maxlength)} min=${l(this.min)} max=${l(this.max)} .value=${l2((_a = this.value) != null ? _a : "")} autocapitalize=${l(this.autocapitalize)} autocorrect=${l(this.autocorrect)} autocomplete="off" ?autofocus=${this.autofocus} placeholder=${this.placeholder} spellcheck=${this.spellcheck} pattern=${l(this.pattern)} inputmode=${l(this.inputmode)} aria-labelledby=${l(this.getLabelledBy())} aria-invalid=${this.invalid ? "true" : "false"} @keyup=${this.handleKeyup} @click=${this.handleClick} @change=${this.handleChange} @input=${this.handleInput} @focus=${this.handleFocus} @blur=${this.handleBlur} /></div>${this.renderClearable()}<span part="suffix" class="form-control__control--suffix"><slot name="suffix"></slot></span>`;
  }
  renderBelow() {
    return $`<div class="autocomplete__positioner"><div class=${o({
      autocomplete__panel: true,
      "autocomplete__panel--open": this.open
    })} @sl-select=${this.handleMenuItemSelection} >${this.renderMenu()}</div></div>`;
  }
};
FadvAutocomplete.styles = [...FormControl.styles, ...FadvInput.styles, autocomplete_styles_default];
__decorateClass([
  t()
], FadvAutocomplete.prototype, "open", 2);
__decorateClass([
  t()
], FadvAutocomplete.prototype, "hasSelectedMenuItem", 2);
__decorateClass([
  i(".form-control__control")
], FadvAutocomplete.prototype, "input", 2);
__decorateClass([
  i(".form-control__control-host")
], FadvAutocomplete.prototype, "host", 2);
__decorateClass([
  i(".autocomplete__panel")
], FadvAutocomplete.prototype, "panel", 2);
__decorateClass([
  i(".autocomplete__positioner")
], FadvAutocomplete.prototype, "positioner", 2);
__decorateClass([
  i("fadv-menu")
], FadvAutocomplete.prototype, "menu", 2);
__decorateClass([
  e({ type: Array })
], FadvAutocomplete.prototype, "suggestions", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvAutocomplete.prototype, "clearable", 2);
__decorateClass([
  e({ type: Number })
], FadvAutocomplete.prototype, "minlength", 2);
__decorateClass([
  e({ type: Number })
], FadvAutocomplete.prototype, "maxlength", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "min", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "max", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "pattern", 2);
__decorateClass([
  e({ type: Boolean, reflect: true })
], FadvAutocomplete.prototype, "required", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "autocapitalize", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "autocorrect", 2);
__decorateClass([
  e({ reflect: true, type: Boolean })
], FadvAutocomplete.prototype, "autofocus", 2);
__decorateClass([
  e({
    converter: booleanAttributeConverter,
    reflect: true,
    type: Boolean
  })
], FadvAutocomplete.prototype, "spellcheck", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "inputmode", 2);
__decorateClass([
  e()
], FadvAutocomplete.prototype, "value", 2);
__decorateClass([
  watch("open", { waitUntilFirstUpdate: true })
], FadvAutocomplete.prototype, "handleOpenChange", 1);
__decorateClass([
  watch("hasSelectedMenuItem", { waitUntilFirstUpdate: true }),
  watch("hasFocus", { waitUntilFirstUpdate: true }),
  watch("suggestions", { waitUntilFirstUpdate: true })
], FadvAutocomplete.prototype, "handleSuggestionsChange", 1);
__decorateClass([
  watch("disabled")
], FadvAutocomplete.prototype, "handleDisabledChange", 1);
FadvAutocomplete = __decorateClass([
  n("fadv-autocomplete")
], FadvAutocomplete);
setDefaultAnimation("autocomplete.show", {
  keyframes: [
    { opacity: 0, transform: "scale(0.9)" },
    { opacity: 1, transform: "scale(1)" }
  ],
  options: { duration: 150, easing: "ease" }
});
setDefaultAnimation("autocomplete.hide", {
  keyframes: [
    { opacity: 1, transform: "scale(1)" },
    { opacity: 0, transform: "scale(0.9)" }
  ],
  options: { duration: 150, easing: "ease" }
});

export {
  FadvAutocomplete
};
